import { Helmet } from "react-helmet-async";

import ContactDetails from "components/pages/ContactUs/ContactDetails";
import PageBanner from "components/common/PageBanner";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const careerSections = [
  {
    heading: "Mô tả công việc",
    bulletPoints: [
      "Giảng dạy các khóa học Tiếng Anh theo chuẩn Cambridge (Starters, Movers, Flyers, KET, PET, FCE...).",
      "Chuẩn bị giáo án và tài liệu giảng dạy theo khung chương trình của Trung tâm.",
      "Theo dõi, đánh giá kết quả học tập của học viên, phối hợp cùng bộ phận đào tạo và phụ huynh để nâng cao hiệu quả học tập.",
      "Tham gia các hoạt động đào tạo, hội thảo nâng cao chuyên môn do Trung tâm tổ chức.",
      "Gọi điện trao đổi tình hình học tập của học viên định kỳ.",
      "Đánh giá mức độ hài lòng của phụ huynh định kỳ.",
    ],
  },
  {
    heading: "Yêu cầu",
    bulletPoints: [
      "Tốt nghiệp chuyên ngành Sư phạm Tiếng Anh hoặc các ngành liên quan.",
      "Có chứng chỉ giảng dạy quốc tế (CELTA, TESOL, TEFL…) là một lợi thế.",
      "Phát âm chuẩn, có kinh nghiệm giảng dạy tiếng Anh trẻ em và Cambridge từ 6 tháng trở lên.",
      "Nhiệt huyết, yêu nghề, có khả năng truyền cảm hứng cho học viên.",
    ],
  },
  {
    heading: "Quyền lợi",
    bulletPoints: [
      "Mức lương: theo giờ hoặc giáo viên cơ hữu (thu nhập 14-27 triệu, đảm bảo tối thiểu 6 lớp giảng dạy).",
      "Được đào tạo nội bộ, tham gia các buổi workshop nâng cao chuyên môn.",
      "Môi trường làm việc thân thiện, đội ngũ giáo viên trong và ngoài nước chuyên nghiệp.",
      "Có cơ hội ký hợp đồng dài hạn, chế độ thưởng và phúc lợi theo quy định của Trung tâm.",
    ],
  },
  {
    heading: "Hồ sơ ứng tuyển",
    bulletPoints: [
      "CV tiếng Anh hoặc tiếng Việt.",
      "Bằng cấp, chứng chỉ liên quan.",
      "Video demo giảng dạy (nếu có).",
    ],
  },
];

function Career() {
  return (
    <Stack spacing={10}>
      <Helmet>
        <title>Tuyển dụng The English Tree</title>
        <meta
          name="description"
          content="Liên lạc theo số 0966 766 839 hoặc theenglishtree.edu@gmail.com."
        />
        <link rel="canonical" href="https://englishtree.edu.vn/tuyen-dung" />
      </Helmet>

      <PageBanner
        backgroundImage="/images/yellow-banner.png"
        heading="Tuyển dụng"
        pageName="Tuyển dụng"
      />

      <Stack spacing={4}>
        <Stack direction="row" justifyContent="center">
          <Typography
            className="highlight"
            variant="h2"
            color="info.main"
            align="center"
          >
            Join Us
          </Typography>
        </Stack>

        <Stack direction="row" justifyContent="center" padding={2}>
          <Stack width={750}>
            <Typography variant="body1" color="info.main">
              <div>
                <p>
                  <span style={{ fontWeight: "bold" }}>Vị trí:</span> Giáo viên
                  Tiếng Anh – Chương trình Cambridge
                </p>
                <p>
                  <span style={{ fontWeight: "bold" }}>Đơn vị:</span> Hệ thống
                  Trung tâm Anh ngữ The English Tree
                </p>
              </div>
            </Typography>

            {careerSections.map(({ heading, bulletPoints }) => (
              <Typography key={heading} variant="body1" color="info.main">
                <p style={{ fontWeight: "bold" }}>{heading}:</p>
                <ul
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {bulletPoints.map((bulletPoint) => (
                    <li key={bulletPoint}>{bulletPoint}</li>
                  ))}
                </ul>
              </Typography>
            ))}
          </Stack>
        </Stack>
      </Stack>

      <ContactDetails />
    </Stack>
  );
}

export default Career;
